import { Component } from '@angular/core';
import { ProductWiseChartHandler } from './productWiseChart.handler.';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: 'sym-product-chart',
  templateUrl: './productWiseChart.component.html',
  styleUrls: ['./productWiseChart.component.scss'],
})
export class ProductWiseChartComponent extends ProductWiseChartHandler {
  constructor(public service: DashboardService, public settingService: SettingService) {
    super(service, settingService);
  }
}
